import { Component, OnInit } from '@angular/core';
import {FormBuilder,FormGroup,Validators} from '@angular/forms'
import { FileUploadService } from '../file-upload.service';


@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {

  constructor(private fb: FormBuilder,private ul:FileUploadService) { }
  dataForm : FormGroup
  ngOnInit(): void {
    this.dataForm = this.fb.group({
        profile:['']
    })
  }


  onFileChange(event){
    if(event.target.files.length>0){
      const file = event.target.files[0]
      console.log(file);
      this.dataForm.get('profile').setValue(file);
    }
  }

  uploadFile(){
    const formData = new FormData();
    formData.append('profile',this.dataForm.get('profile').value);

    this.ul.uploadData(formData).subscribe(
      (res)=>console.log(res),
      (err)=>console.log(err)
    )
  }

}
